export default {
  PASSWORD_REQUIRMENTS:
    "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.",
  EMAIL_ERROR_MESSAGE: "Please enter a valid email",
};
